import type { IAdmin } from 'src/models/IAdmin';
import Link from 'next/link';

import { getDate } from 'assets/utils/Time/getDate';
import { role, status } from 'src/const/userLib';

import type { IColConfig } from 'components/UIElements/ConfigurableList';
import { ConfigurableList } from 'components/UIElements/ConfigurableList';

interface Props {
  adminsList: IAdmin[];
}

export const AdminsTable = ({ adminsList }: Props) => {
  // Компоненты для рендера элементов в шапке таблиц
  const renderName = (admin: IAdmin) => (
    <Link className="link" style={{ cursor: 'pointer' }} href={`admins/${admin.id}`}>
      {`${admin.surname || ''} ${admin.name}`}
    </Link>
  );
  const renderRole = (admin: IAdmin) => <span>{role[admin.role]}</span>;
  const renderStatus = (admin: IAdmin) => <span>{status[admin.status]}</span>;
  const renderDate = (admin: IAdmin) => <span>{admin.last_seen ? getDate(admin.last_seen) : '—'}</span>;

  const colsOptions: IColConfig[] = [
    { title: 'Фамилия Имя', size: 220, render: renderName },
    { title: 'Логин', fieldname: 'email', size: 250 },
    { title: 'Роль', size: 220, render: renderRole },
    { title: 'Статус', size: 150, render: renderStatus },
    { title: 'Последний вход', size: 130, render: renderDate },
  ];

  return <ConfigurableList list={adminsList} cols={colsOptions} />;
};
